module.exports = "<a class=\"share-modal__link\" href=\"<%=url%>\" target=\"_blank\" data-link-name=\"social <%=css%>\">\n    <div class=\"share-modal__item button button--xlarge share-modal__item--<%=css%>\">\n        <%= icon %>\n        <%=text%>\n    </div>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/content/share-button-mobile.html
// module id = 723
// module chunks = 2